import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M14.5,11.66a.51.51,0,0,0-.24-.43.52.52,0,0,0-.5,0L7.61,14.54a.24.24,0,0,1-.23,0L2.82,12.27a.3.3,0,0,1-.14-.22.25.25,0,0,1,.14-.23L8,9A1,1,0,1,0,7,7.28l-6.5,3.5a1,1,0,0,0-.53.9v7.73a.49.49,0,0,0,.26.44l7,3.75a.53.53,0,0,0,.24.06.54.54,0,0,0,.25-.06l6.5-3.75a.52.52,0,0,0,.25-.44Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M23.2,11.18a.24.24,0,0,1-.2-.24V3.16a2,2,0,0,0-2-2h-.5a.25.25,0,0,1-.2-.09L20.24,1A2,2,0,0,0,17.41.85l-5.56,5a1,1,0,0,0-.07,1.41l0,0a.26.26,0,0,1,.07.19.32.32,0,0,1-.09.17L9,10.16a.73.73,0,0,0-.06,1.05.75.75,0,0,0,1.06.07l2.84-2.52a.22.22,0,0,1,.3,0,1,1,0,0,0,1.41.07l5.57-5a2.18,2.18,0,0,0,.42-.54.24.24,0,0,1,.22-.13h0a.25.25,0,0,1,.25.25v7.75a2,2,0,0,0,2,2,1,1,0,0,0,.2-2Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }